import { Mail, Phone } from 'lucide-react'
import { type ReactElement } from 'react'

import { Item } from '@orus.eu/pharaoh-next/components/ui/item'
import { mailtoHref, telHref } from '@orus.eu/pharaoh-next/lib/contact-href'

import whatsappLogo from '../assets/whatsapp.png'

import { ContactLinkItem } from './contact-link-item.tsx'

type OrusContactChannelsProps = {
  email: string | undefined
  whatsappLink: string | undefined
  phone: string | undefined
}

export function OrusContactChannels({ email, whatsappLink, phone }: OrusContactChannelsProps): ReactElement {
  return (
    <Item.Group variant="outline">
      {whatsappLink ? (
        <ContactLinkItem
          icon={<img src={whatsappLogo} alt="" className="size-full" />}
          label="WhatsApp"
          href={whatsappLink}
        />
      ) : null}

      {email ? (
        <ContactLinkItem icon={<Mail aria-hidden className="size-[16px]" />} label={email} href={mailtoHref(email)} />
      ) : null}

      {phone ? (
        <ContactLinkItem icon={<Phone aria-hidden className="size-[16px]" />} label={phone} href={telHref(phone)} />
      ) : null}
    </Item.Group>
  )
}
